import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = (v) => (v ? new Date(v).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "short", timeStyle: "short" }) : "-");

// Riwayat perubahan kode dari audit log; tidak tampil bila belum pernah diubah.
export function KodeHistory({ kind, id, kode }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows([]);
    api.get(`/network/kode-history/${kind}/${id}`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [kind, id, kode]);
  if (!rows.length) return null;
  return (
    <details className="text-xs" data-testid={`kode-history-${kind}`}>
      <summary className="cursor-pointer font-semibold text-[#6B7280]">Riwayat Kode ({rows.length})</summary>
      <ul className="mt-1 space-y-1">{rows.map((r, i) => (
        <li key={`${r.at}-${i}`} className="rounded bg-[#F8F9FA] p-1.5" data-testid={`kode-history-row-${i}`}>
          <span className="font-mono-tab">{r.from}</span> → <b className="font-mono-tab">{r.to}</b>
          <span className="text-[#6B7280]"> · {fmt(r.at)}{r.by_name || r.by ? ` · ${r.by_name || r.by}` : ""}</span></li>))}</ul>
    </details>
  );
}
